<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="deviceId">
          <el-input
            v-model="queryForm.deviceId"
            @keyup.enter.native="query"
            placeholder="设备编号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="hardVer">
          <el-input
            v-model="queryForm.hardVer"
            @keyup.enter.native="query"
            placeholder="硬件版本号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="status">
          <el-select
            v-model="queryForm.status"
            @keyup.enter.native="query"
            placeholder="请选择升级状态"
          >
            <el-option
              v-for="item in upgradeStatusList"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button
          v-if="hasPerm('upgrade:report:log:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('upgrade:report:log:list')" @click="reset"
          >取消</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
    >
      <el-table-column
        type="index"
        align="center"
        label="序号"
        width="55"
      ></el-table-column>
      <el-table-column prop="deviceId" label="设备编号"></el-table-column>
      <el-table-column prop="iccid" label="ICCID"></el-table-column>
      <el-table-column
        prop="deviceModel"
        label="设备型号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hardVer"
        label="硬件版本号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="status" label="升级状态"></el-table-column>
      <el-table-column
        prop="addTime"
        label="升级时间"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm: {
        deviceId: "",
        hardVer: "",
        status: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableVal: [],
      tableData: [],
      upgradeStatusList: [],
    }
  },
  created() {
    this.getLogList()
    this.getUpgradeStatusList()
  },
  methods: {
    async getLogList() {
      let _this = this
      let obj = {}
      obj.deviceId = _this.queryForm.deviceId
      obj.hardVer = _this.queryForm.hardVer
      obj.status = _this.queryForm.status
      obj.limit = _this.limit
      obj.page = _this.currentPage
      let { data: res } = await _this.$axios.get(
        "/api/upgrade/report/log/list",
        {
          params: obj,
        }
      )
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      }
    },
    query() {
      this.getLogList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.getLogList()
    },
    async getUpgradeStatusList() {
      let _this = this
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/" + "upgradeReport"
      )
      if (res.code == 1) {
        _this.upgradeStatusList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getLogList()
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  padding: 0 20px;
  background: #fff;
}
</style>
